/* ═══════════════════════════════════════
   Milan Clothing — Shared JS
   Drop in /assets/ and include in theme.liquid
   ═══════════════════════════════════════ */

(function(){
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Scroll reveal ── */
  function initReveal(){
    var items = document.querySelectorAll('.mc-rv, .mc-wipe');
    if(!items.length) return;
    if(reduce || !('IntersectionObserver' in window)){
      items.forEach(function(el){ el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -7% 0px' });
    items.forEach(function(el){ io.observe(el); });
  }

  /* ── Sticky mobile CTA ── */
  function initSticky(){
    var bar = document.getElementById('mc-sticky-bar');
    if(!bar) return;
    document.body.classList.add('mc-has-sticky');
    var shown = false;
    window.addEventListener('scroll', function(){
      var s = window.scrollY > 500;
      if(s !== shown){
        bar.classList.toggle('mc-sticky--show', s);
        shown = s;
      }
    }, { passive: true });
  }

  /* ── Add to bag (AJAX cart) ── */
  function initCartButtons(){
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-product-id]');
      if(!btn) return;
      e.preventDefault();
      var pid = btn.dataset.productId;
      if(!pid) return;
      var orig = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: pid, quantity: 1 })
      })
      .then(function(r){ return r.json(); })
      .then(function(){
        btn.textContent = 'Added ✓';
        setTimeout(function(){ btn.textContent = orig; btn.disabled = false; }, 2200);
        /* update cart count if your theme has [data-cart-count] */
        fetch('/cart.js')
          .then(function(r){ return r.json(); })
          .then(function(c){
            document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = c.item_count; });
          });
      })
      .catch(function(){
        btn.textContent = 'Error — retry';
        setTimeout(function(){ btn.textContent = orig; btn.disabled = false; }, 2200);
      });
    });
  }

  /* ── Init ── */
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){
      initReveal(); initSticky(); initCartButtons();
    });
  } else {
    initReveal(); initSticky(); initCartButtons();
  }

  /* re-run reveal after Shopify section events */
  document.addEventListener('shopify:section:load', initReveal);

})();
